import { createFileRoute } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import { IconDownload } from "@/Icon/Download";
import { useState } from "react";
import { useUserPhoto } from "~/services/customer/common";
import { Loading } from "@/Loading";

interface GalleryDetailParams {
  albumSeq?: string;
}

export const Route = createFileRoute("/customer/layout/gallery-detail")({
  component: GalleryDetail,
  validateSearch: (search: Record<string, unknown>): GalleryDetailParams => {
    return {
      albumSeq: search.albumSeq as string | undefined,
    };
  },
});

function GalleryDetail() {
  const { albumSeq } = Route.useSearch();
  const [showDownloadMessage, setShowDownloadMessage] = useState(false);

  // API 데이터 가져오기
  const {
    data: photoData,
    isLoading,
    error,
  } = useUserPhoto(parseInt(albumSeq || "0"));

  const handleDownload = async () => {
    if (!photoData?.data?.fileUrl) return;

    try {
      const response = await fetch(photoData.data.fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `image-${photoData.data.albumSeq}.jpg`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      // 다운로드 메시지 표시
      setShowDownloadMessage(true);
      setTimeout(() => setShowDownloadMessage(false), 2000);
    } catch (error) {
      console.error("다운로드 중 오류 발생:", error);
    }
  };

  // 로딩 상태
  if (isLoading) {
    return (
      <div className="flex flex-col flex-auto bg-black">
        <LayoutHeader
          title="사진첩"
          hasBackBtn
          className="bg-black text-white"
        />
        <div className="flex-1 flex items-center justify-center">
          <Loading />
        </div>
      </div>
    );
  }

  // 에러 상태
  if (error || !photoData?.data) {
    return (
      <div className="flex flex-col flex-auto bg-black">
        <LayoutHeader
          title="사진첩"
          hasBackBtn
          className="bg-black text-white"
        />
        <div className="flex-1 flex items-center justify-center">
          <p className="text-white">사진을 불러오는 중 오류가 발생했습니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col flex-auto bg-black">
      <LayoutHeader title="사진첩" hasBackBtn className="bg-black text-white" />
      <div className="flex-1 flex items-center justify-center relative">
        <img
          src={photoData.data.fileUrl}
          alt="상세 이미지"
          className="w-full h-full object-contain"
        />
        {/* 다운로드 버튼 */}
        <button
          onClick={handleDownload}
          className="absolute top-4 right-4 p-2 bg-black bg-opacity-50 rounded-full text-white"
        >
          <IconDownload />
        </button>
      </div>
      {showDownloadMessage && (
        <div className="fixed bottom-4 left-4 right-4">
          <div className="bg-zinc-700 text-white p-4 rounded-lg text-center">
            사진이 다운로드 되었어요.
          </div>
        </div>
      )}
    </div>
  );
}
